export default __webpack_public_path__ + "static/terms-ca37ae7badc20a9840cc1d4d0ba2f56d.png";